import { Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { OsXFinancialFilterOsBy } from '@/core/domain/questReport/Reports/OsXFinancial/OsXFinancial.types';

const OsForm = () => {
  const intl = useIntl();
  const { Title } = Typography;
  return (
    <Row>
      <Col sm={24}>
        <Title level={5}>
          {intl.formatMessage({
            id: 'movimentOsXFinancial.form.overview.filterBudgetBy',
          })}
        </Title>
        <Form.Item
          name="filterOsBy"
          initialValue={OsXFinancialFilterOsBy.delivery}
          noStyle
        >
          <Radio.Group optionType="button" buttonStyle="solid" size="large">
            <Radio value={OsXFinancialFilterOsBy.delivery}>
              {intl.formatMessage({
                id: 'movimentOsXFinancial.form.overview.filterBudgetBy.delivery',
              })}
            </Radio>
            <Radio value={OsXFinancialFilterOsBy.authorization}>
              {intl.formatMessage({
                id: 'movimentOsXFinancial.form.overview.filterBudgetBy.authorization',
              })}
            </Radio>
            <Radio value={OsXFinancialFilterOsBy.closure}>
              {intl.formatMessage({
                id: 'movimentOsXFinancial.form.overview.filterBudgetBy.closure',
              })}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default OsForm;
